import React, { useEffect, useState } from 'react';
import Footer from '../components/resuableComponents/Footer';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { Watermark } from 'antd';
import { Button, Divider, Modal } from 'antd';
import { Box, Grid, FormControlLabel } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { AddSearchFlightDispatch } from '../reducers/HomeReducer';
import { useLocation } from 'react-router-dom';
import FlightResultSkeleton from '../components/resuableComponents/FlightResultSkeleton';
import TopDrawer from '../components/resuableComponents/TopDrawer';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import FlightRow from '../components/resuableComponents/FlightRow';
import ModifySearchFlight from '../components/resuableComponents/ModifySearchFlight';
import HorLoader from '../components/resuableComponents/HorLoader';
import FlightDetails from '../components/resuableComponents/FlightDetails';

const fareType = ['Refundable', 'Non-Refundable'];
const stopType = ['Non-Stop', '1-Stop', '2+Stop'];
const SearchResultPage = () => {
	const { tboflight, loading } = useSelector((state) => state.tbo);
	const { etravresult } = useSelector((state) => state.etrav);
	const { tjkresult } = useSelector((state) => state.tripjack);
	const { onwardFlight } = useSelector((state) => state.ui);
	const dispatch = useDispatch();
	const [result, setResult] = useState([]);
	const [airlineS, setairlineS] = useState('');
	const [fare, setFare] = useState('');
	const [stop, setStop] = useState('');
	const [step, setStep] = useState('fld');
	const [draw, setDraw] = useState(false);
	const [loadings, setLoading] = useState(false);
	const [open, setOpen] = useState(false);
	const [mod, setMod] = useState(false);
	const [scrollVal, SetScrollVal] = useState(10);
	const [hasMorefilterData, SethasMoreFilterData] = useState(true);
	const location = useLocation();
	const fetchMoreData = () => {
		// if (eltbo === fals && letrav === false && trp === false) {
		// 	if (scrollVal >= filterData.length) {
		// 		SethasMoreFilterData(false);
		// 	}
		// }

		setTimeout(() => {
			SetScrollVal(scrollVal + 5);
		}, 500);
	};
	const handleStep = (val) => {
		setStep(val);
	};
	useEffect(() => {
		window.scrollTo(0, 0);
		dispatch(AddSearchFlightDispatch(location.state));
	}, []);
	let combineflightData = [];
	let filterData = [];
	let filterAirlineTBO = [];

	if (loading) {
		console.log('Loading');
	} else {
		let tbo =
			tboflight &&
			tboflight?.result &&
			tboflight?.result?.Response &&
			tboflight?.result?.Response?.Results[0].length > 0 &&
			tboflight?.result?.Response?.Results[0];
		let etrav =
			etravresult &&
			etravresult?.result &&
			etravresult?.result?.TripDetails[0]?.Flights;
		let tjk =
			tjkresult &&
			tjkresult?.result?.searchResult &&
			tjkresult?.result?.searchResult?.tripInfos?.ONWARD?.length > 0 &&
			tjkresult?.result?.searchResult?.tripInfos?.ONWARD;
		console.log('etravh', etrav);
		if (tbo?.length > 0 && etrav?.length > 0 && tjk?.length > 0) {
			combineflightData = [...tbo, ...etrav, ...tjk];
		} else if (tbo?.length > 0 && etrav?.length > 0) {
			combineflightData = [...tbo, ...etrav];
		} else if (tbo?.length > 0 && tjk?.length > 0) {
			combineflightData = [...tbo, ...tjk];
		} else if (etrav?.length > 0 && tjk?.length > 0) {
			combineflightData = [...etrav, ...tjk];
		} else if (etrav?.length > 0 && tbo?.length > 0) {
			combineflightData = [...etrav, ...tbo];
		} else if (tbo?.length > 0) {
			combineflightData = [...tbo];
		} else if (etrav?.length > 0) {
			combineflightData = [...etrav];
		} else if (tjk?.length > 0) {
			combineflightData = [...tjk];
		}
		filterData =
			combineflightData &&
			combineflightData.length > 0 &&
			combineflightData.slice().sort((a, b) => {
				let first =
					a.Supplier === 'TBO'
						? Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  )
						: a.Supplier === 'ETR'
						? Number(Math.round(a.Fares.Total_Amount))
						: a.Supplier === 'TJK'
						? Number(Math.round(a.totalPriceList.fd.Total_Amount))
						: '';
				let second =
					b.Supplier === 'TBO'
						? Number(
								Number(Math.round(b.Fare.Total_Amount)) -
									Number(Math.round(b.Fare.MFB_Discount))
						  )
						: b.Supplier === 'ETR'
						? Number(Math.round(b.Fares.Total_Amount))
						: b.Supplier === 'TJK'
						? Number(Math.round(b.totalPriceList.fd.Total_Amount))
						: '';
				return first - second;
			});
		if (
			tboflight &&
			tboflight?.result &&
			tboflight?.result?.Response &&
			tboflight?.result?.Response?.Results[0].length > 0
		) {
			filterAirlineTBO = [
				...new Set(
					tboflight &&
						tboflight?.result &&
						tboflight?.result?.Response &&
						tboflight?.result?.Response?.Results[0].length > 0 &&
						tboflight?.result?.Response?.Results[0].map(
							(item) => item.Segments[0]?.[0]?.Airline.AirlineName
						)
				),
			];
		}
	}
	const handleAirline = (event) => {
		SetScrollVal(10);
		console.log('airline', event.target.name);
		setairlineS(event.target.name);
		if (airlineS === event.target.name) {
			setResult([]);
			setairlineS('');
		} else {
			let filterDataStop = [];
			let filterCombineStop = [];
			let tbo = [];
			if (tboflight) {
				tboflight &&
					tboflight &&
					tboflight.result &&
					tboflight.result.Response &&
					tboflight.result.Response.Results[0].length > 0 &&
					tboflight.result.Response.Results[0].map((item) => {
						if (
							item.Segments[0]?.[0]?.Airline.AirlineName === event.target.name
						) {
							tbo.push({
								...item,
							});
						}
					});
			}
			filterCombineStop = [...tbo];
			filterDataStop =
				filterCombineStop &&
				filterCombineStop.length > 0 &&
				filterCombineStop.slice().sort((a, b) => {
					let first = a.Fare
						? Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  )
						: a.Fares
						? Number(Math.round(a.Fares.Total_Amount))
						: a.totalPriceList
						? Number(Math.round(a.totalPriceList.fd.Total_Amount))
						: Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  );
					let second = b.Fare
						? Number(
								Number(Math.round(b.Fare.Total_Amount)) -
									Number(Math.round(b.Fare.MFB_Discount))
						  )
						: b.Fares
						? Number(Math.round(b.Fares.Total_Amount))
						: b.totalPriceList
						? Number(Math.round(b.totalPriceList.fd.Total_Amount))
						: Number(Math.round(b.Fare.Total_Amount)) -
						  Number(Math.round(b.Fare.MFB_Discount));
					return first - second;
				});
			setResult(filterDataStop);
			console.log('filterDataStop', filterDataStop);
			console.log('filterCombineStop', filterCombineStop);
		}
	};
	const handleFareType = (event) => {
		// SethasMoreResult(true);
		// SetScrollValResult(10);
		SetScrollVal(10);
		console.log('airline', event.target.name);
		setFare(event.target.name);
		if (fare === event.target.name) {
			setResult([]);
			setFare('');
		} else {
			let filterDataStop = [];
			let filterCombineStop = [];
			let tbo = [];
			if (tboflight) {
				tboflight &&
					tboflight.result &&
					tboflight.result.Response &&
					tboflight.result.Response.Results[0].length > 0 &&
					tboflight.result.Response.Results[0].map((item) => {
						if (
							event.target.name === 'Refundable'
								? item.IsRefundable
								: !item.IsRefundable
						) {
							tbo.push({
								...item,
							});
						}
					});
			}
			filterCombineStop = [...tbo];
			filterDataStop =
				filterCombineStop &&
				filterCombineStop.length > 0 &&
				filterCombineStop.slice().sort((a, b) => {
					let first = a.Fare
						? Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  )
						: a.Fares
						? Number(Math.round(a.Fares.Total_Amount))
						: a.totalPriceList
						? Number(Math.round(a.totalPriceList.fd.Total_Amount))
						: Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  );
					let second = b.Fare
						? Number(
								Number(Math.round(b.Fare.Total_Amount)) -
									Number(Math.round(b.Fare.MFB_Discount))
						  )
						: b.Fares
						? Number(Math.round(b.Fares.Total_Amount))
						: b.totalPriceList
						? Number(Math.round(b.totalPriceList.fd.Total_Amount))
						: Number(Math.round(b.Fare.Total_Amount)) -
						  Number(Math.round(b.Fare.MFB_Discount));
					return first - second;
				});
			setResult(filterDataStop);
			console.log('filterDataStop', filterDataStop);
			console.log('filterCombineStop', filterCombineStop);
		}
	};
	const handleStopType = (event) => {
		// SethasMoreResult(true);
		// SetScrollValResult(10);
		SetScrollVal(10);
		console.log('airline', event.target.name);
		setStop(event.target.name);
		if (stop === event.target.name) {
			setResult([]);
			setStop('');
		} else {
			let filterDataStop = [];
			let filterCombineStop = [];
			let tbo = [];
			if (tboflight) {
				tboflight &&
					tboflight.result &&
					tboflight.result.Response &&
					tboflight.result.Response.Results[0].length > 0 &&
					tboflight.result.Response.Results[0].map((item) => {
						if (
							event.target.name === 'Non-Stop'
								? item.Segments[0].length === 1
								: event.target.name === '1-Stop'
								? item.Segments[0].length === 1
								: item.Segments[0].length > 1
						) {
							tbo.push({
								...item,
							});
						}
					});
			}
			filterCombineStop = [...tbo];
			filterDataStop =
				filterCombineStop &&
				filterCombineStop.length > 0 &&
				filterCombineStop.slice().sort((a, b) => {
					let first = a.Fare
						? Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  )
						: a.Fares
						? Number(Math.round(a.Fares.Total_Amount))
						: a.totalPriceList
						? Number(Math.round(a.totalPriceList.fd.Total_Amount))
						: Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  );
					let second = b.Fare
						? Number(
								Number(Math.round(b.Fare.Total_Amount)) -
									Number(Math.round(b.Fare.MFB_Discount))
						  )
						: b.Fares
						? Number(Math.round(b.Fares.Total_Amount))
						: b.totalPriceList
						? Number(Math.round(b.totalPriceList.fd.Total_Amount))
						: Number(Math.round(b.Fare.Total_Amount)) -
						  Number(Math.round(b.Fare.MFB_Discount));
					return first - second;
				});
			setResult(filterDataStop);
			console.log('filterDataStop', filterDataStop);
			console.log('filterCombineStop', filterCombineStop);
		}
	};
	function progressBarScroll() {
		let winScroll =
				document.body.scrollTop || document.documentElement.scrollTop,
			height =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight,
			scrolled = (winScroll / height) * 100;
		document.getElementById('progressBar').style.width = scrolled + '%';
	}

	window.onscroll = function () {
		progressBarScroll();
	};
	return (
		<div>
			<Navbar />
			<div className='header' style={{ marginTop: 80 }}>
				<div className='progress-container'>
					<div className='progress-bar' id='progressBar'></div>
				</div>
			</div>
			{filterData?.length > 0 && mod ? <ModifySearchFlight /> : ''}
			{filterData?.length > 0 ? '' : <HorLoader />}
			{filterData?.length > 0 ? (
				<Box
					style={{
						background: '#FFF',
						boxShadow: '0 0 10px rgba(0,0,0,.3)',
						paddingLeft: 100,
						paddingRight: 100,
						paddingTop: 10,
					}}>
					<Grid container spacing={2}>
						<Grid item xs={12} lg={3}>
							<Box>
								<span>Stops</span>
							</Box>
							<Box style={{ display: 'flex', flexWrap: 'wrap' }}>
								{stopType &&
									stopType.length > 0 &&
									stopType.map((i, index) => {
										return (
											<FormControlLabel
												control={
													<Checkbox
														checked={stop === i ? true : false}
														onChange={handleStopType}
														name={`${i}`}
														sx={{}}
													/>
												}
												label={
													<>
														<span style={{ fontSize: 12 }}>{i}</span>
													</>
												}
											/>
										);
									})}
							</Box>
						</Grid>
						<Grid item xs={12} lg={4}>
							<Box>
								<span>Airline</span>
							</Box>

							<Box style={{ display: 'flex', flexWrap: 'wrap' }}>
								{filterAirlineTBO &&
									filterAirlineTBO.length > 0 &&
									filterAirlineTBO.map((i, index) => {
										return index < 4 ? (
											<FormControlLabel
												control={
													<Checkbox
														checked={airlineS === i ? true : false}
														onChange={handleAirline}
														name={`${i}`}
														sx={{}}
													/>
												}
												label={
													<>
														<span style={{ fontSize: 12 }}>{i}</span>
													</>
												}
											/>
										) : (
											''
										);
									})}
							</Box>
						</Grid>
						<Grid item xs={12} lg={3}>
							<Box>
								<span>Fare Type</span>
							</Box>
							<Box style={{ display: 'flex', flexWrap: 'wrap' }}>
								{fareType &&
									fareType.length > 0 &&
									fareType.map((i, index) => {
										return (
											<FormControlLabel
												control={
													<Checkbox
														checked={fare === i ? true : false}
														onChange={handleFareType}
														name={`${i}`}
														sx={{}}
													/>
												}
												label={
													<>
														<span style={{ fontSize: 12 }}>{i}</span>
													</>
												}
											/>
										);
									})}
							</Box>
						</Grid>
						<Grid item xs={12} lg={2}>
							<Box style={{ display: 'flex', justifyContent: 'space-between' }}>
								<Box
									style={{
										display: 'flex',
										alignItems: 'center',
										cursor: 'pointer',
									}}
									onClick={() => setDraw(true)}>
									More{' '}
									<i class='fa fa-angle-down' style={{ marginLeft: 5 }}></i>
								</Box>
								<Box
									onClick={() => (mod ? setMod(false) : setMod(true))}
									style={{
										display: 'flex',
										alignItems: 'center',
										cursor: 'pointer',
									}}>
									Modify Search{' '}
									<i class='fa fa-angle-down' style={{ marginLeft: 5 }}></i>
								</Box>
							</Box>
						</Grid>
					</Grid>
				</Box>
			) : (
				''
			)}
			<Watermark content='Musafir Bazar'>
				<Box
					style={{
						marginTop: 50,
						marginBottom: 50,
						paddingLeft: 100,
						paddingRight: 100,
					}}>
					<Grid container spacing={4}>
						<Grid item xs={12} lg={8}>
							<Box
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
									marginBottom: 10,
								}}>
								<h2 style={{ fontSize: 26 }}>
									{`Flight From ${location.state.Segments[0].Origin} to ${
										location.state.Segments[0].Destination
									}(${
										filterData?.length ? filterData?.length : ''
									})`.toLocaleUpperCase()}
								</h2>
								<h3 style={{ fontSize: 20 }}>
									{location.state.Segments[0].PreferredDepartureTime}
								</h3>
							</Box>
							{result ? (
								result?.length > 0 ? (
									<InfiniteScroll
										dataLength={scrollVal}
										next={fetchMoreData}
										hasMore={hasMorefilterData}
										loader={<h4 style={{ textAlign: 'center' }}>Loading...</h4>}
										endMessage={
											<p style={{ textAlign: 'center' }}>
												<b>No More Flights</b>
											</p>
										}>
										{result?.map((item, index) => {
											return index < scrollVal ? (
												<>
													<FlightRow item={item} location={location} />
												</>
											) : (
												''
											);
										})}
									</InfiniteScroll>
								) : filterData?.length > 0 ? (
									<InfiniteScroll
										dataLength={scrollVal}
										next={fetchMoreData}
										hasMore={hasMorefilterData}
										loader={<h4 style={{ textAlign: 'center' }}>Loading...</h4>}
										endMessage={
											<p style={{ textAlign: 'center' }}>
												<b>No More Flights</b>
											</p>
										}>
										{filterData?.map((item, index) => {
											return index < scrollVal ? (
												<>
													<FlightRow item={item} location={location} />
													{/* <Box
												style={{
													alignItems: 'center',
													borderRadius: 4,
													background: '#fff',
													// filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, .25))',
												}}>
												<span>Flight Details</span>
											</Box> */}
												</>
											) : (
												''
											);
										})}
									</InfiniteScroll>
								) : (
									Array.from(Array(10)).map((i) => {
										return <FlightResultSkeleton />;
									})
								)
							) : (
								Array.from(Array(10)).map((i) => {
									return <FlightResultSkeleton />;
								})
							)}
						</Grid>
						<Grid item xs={12} lg={4}>
							<Box>
								<img src='https://tpc.googlesyndication.com/simgad/16156858053234787891?sqp=4sqPyQQrQikqJwhfEAEdAAC0QiABKAEwCTgDQPCTCUgAUAFYAWBfcAJ4AcUBLbKdPg&rs=AOga4qmd7sh5rWiWjxdzaN9vw44WnXQdZA' />
							</Box>
						</Grid>
					</Grid>
				</Box>
			</Watermark>
			<TopDrawer
				draw={draw}
				setDraw={setDraw}
				filterAirlineTBO={filterAirlineTBO}
				airlineS={airlineS}
				handleAirline={handleAirline}
				fareType={fareType}
				handleFareType={handleFareType}
				fare={fare}
				stopType={stopType}
				handleStopType={handleStopType}
				stop={stop}
			/>
			<FlightDetails />
			<Footer />
		</div>
	);
};

export default SearchResultPage;
